export enum DashboardFilterEnum {
  GoToById,
  Statut,
  Enveloppe,
  Nature,
  Produit,
  Montant,
  Gestionnaire,
  FondEvnt,
  Investisseur,
  InvestisseurPersonneMorale,
  InvestisseurPersonnePhysique,
  Tag,
  Signature,
  Partenaire,
  BordereauDateEnvoi,
  BordereauStatut,
  ErrorPartenaireEmail,
  CommandeAramis,
  IsInvestisseurPersonneMorale,
  Consultant,
  NumeroContrat,
  CreationDateRange,
  UpdateDateRange,
  ModePaiement,
  Demembrement,
}
